






































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { TableStripe } from '@/mixins/tableStripe';
import PagingUnit from '@/components/paging/paging.vue';
import { hiddenDangerLibraryServer, institutionServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class CheckReport extends Vue {
  private tableData: any = [];

  private filterForm: any = {
    deptId: '',
  };
  private subSpaceByAuthOptions: any = [];

  private deptChange(e: any) {
    this.getTableList();
  }
  private getTableList() {
    hiddenDangerLibraryServer
      .getHazardManageStatisticReport({
        deptId: this.filterForm.deptId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data;
        }
      });
  }
  // 部门所有数据
  private getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.getSubSpaceByAuth();
    this.getTableList();
  }
}
